export default __webpack_public_path__ + "static/media/clear.c7cffb01.jpg";